"use client";
import PlainCard from "@/components/plainCard";
import { FEATURES_CONSTANTS } from "./constants";

const FeaturesComponent = () => {
  return <PlainCard {...FEATURES_CONSTANTS} />;
};

export default FeaturesComponent;
